import type { CoreInquiryResponseSingle, ParameterID } from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Get an inquiry details by ID.
 *
 * @endpoint GET /api/saas/me/inquiries/{inquiryId}
 * @scope saas
 * @see https://flecto.dev/api-4724162
 */
export async function getInquiryById(
  inquiryId: ParameterID
): Promise<CoreInquiryResponseSingle> {
  const response = await api.get<CoreInquiryResponseSingle>(
    `/api/saas/me/inquiries/${inquiryId}`
  )

  return response.data
}
